import { createSlice } from "@reduxjs/toolkit";

type ClientNewContactState = {
  isLoadingInfo: boolean;
  actualClientId: number | null;
};

const initialState: ClientNewContactState = {
  isLoadingInfo: true,
  actualClientId: null,
};

export const clientNewContactSlice = createSlice({
  name: "clientNewContact",
  initialState,
  reducers: {
    load: (state, action) => {
      state.actualClientId = action.payload;
      state.isLoadingInfo = false;
    },
    setIsLoadingInfo: (state, action) => {
      state.isLoadingInfo = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { load, setIsLoadingInfo } = clientNewContactSlice.actions;

export const IsLoadingInfo = (state: any) => {
  return state.clientNewContact.isLoadingDrodpdownsInfo;
};

export const SelectActualClientId = (state: any) => {
  return state.clientNewContact.actualClientId;
};

export default clientNewContactSlice.reducer;
